import { mapGetters, mapActions } from "vuex";

export default {
  computed: {
    ...mapGetters({
      direction: "scroller/direction",
      landingIndex: "scroller/landingIndex",
      isMenuOpen: "ui/isMenuOpen",
      isModalOpen: "ui/isModalOpen",
    }),
  },
  methods: {
    sourceClick(key) {
      this.setMainSource(key);
      this.$router.push("/" + key);
    },
    swipeLanding(e) {
      if (e === "left") {
        this.increment();
      } else {
        this.decrement();
      }
    },
    ...mapActions({
      setMainSource: "ui/setMainSource",
      increment: "scroller/increment",
      decrement: "scroller/decrement",
    }),
  },
};
